import { useLang } from '@/i18n';
import EfCountDown from '@elem/ui/ef-count-down';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { useProductStore } from '../../../ProductProvider';
import TimerTips from '../../common/TimerTips';
import styles from './index.module.scss';
import ListA from './ListA';

export default function TheComp() {
    const { systemTime } = useProductStore();
    const { t } = useLang('theProduct.SectionD');
    const { t: t2 } = useLang('theProduct.Common');
    const endTimerA = new Date('2024/08/31 23:00:00 GMT+8').getTime();
    let leftTime = null;
    if (systemTime) {
        leftTime = endTimerA - systemTime;
    }

    return (
        <div className={styles.TheComp} id="section-SectionD">
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <TimerTips title={t('desc')} />
            <EfCountDown
                leftTime={leftTime}
                endTime={endTimerA}
                leftTips={t2('timer_tips')}
                tipsDay={t2('timer_1')}
                tipsHour={t2('timer_2')}
                tipsMinute={t2('timer_3')}
                tipsSecond={t2('timer_4')}
            />
            <ListA />
        </div>
    );
}
